import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    supportedLngs: ['en-US'],

    // Namespace configuration
    ns: ['common', 'auth', 'adventures', 'profile', 'admin'],
    defaultNS: 'common',

    // Backend configuration - load from local public folder
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Language detection
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'adventurecore_language',
    },

    // React-specific
    react: {
      useSuspense: true,
    },

    // Interpolation
    interpolation: {
      escapeValue: false, // React already escapes
    },

    // Debug in development
    debug: false, // Disabled to reduce console noise
  })

export default i18n
